import { Checkbox } from "@mui/material";
import styled from "styled-components";

export const BoxClinicalSignature = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  color: #343536;
  padding: 20px 0;
  gap: 20px;

  .boxSignature {
    border: 1px solid #c5c5c5;
    width: 100%;
  }

  h5 {
    font-weight: bold;
    padding: 15px;
  }

  p {
    font-weight: 500;
    padding: 5px 0;
  }
`;

export const Check = styled(Checkbox)`
  svg {
    font-size: 2rem !important;
  }
`;
